<template>
    <!-- <PageLoading v-if="isLoading" /> -->
    <div class="q-pa-md">
        <q-table
            :data="affiliations"
            :columns="columns"
            :pagination.sync="pagination"
            :rows-per-page-options="rowsPerPageOptions"
            :loading="isFetchingAffiliations"
            binary-state-sort
            row-key="id"
            flat
            @request="request"
        >
            <template v-slot:body-cell-start_date="props">
                <q-td key="start_date" :props="props">
                    {{ formatDate(props.row.start_date) }}
                </q-td>
            </template>
            <template v-slot:body-cell-end_date="props">
                <q-td key="end_date" :props="props">
                    {{ formatDate(props.row.end_date) }}
                </q-td>
            </template>
        </q-table>
        <h6
            v-if="!isFetchingAffiliations && affiliations.length <= 0"
            class="q-mt-md"
        >
            {{ $t('notify.no_affiliations') }}
        </h6>
    </div>
</template>

<script>
// import PageLoading from '@/components/PageLoading'
import notify from '@/local-shared/mixins/notify'
import affiliationsService from '@/services/modules/profile/affiliations'
import formatDate from '@/helpers/date-time'
import store from '@/store'

const loadingKeys = {
    fetchingAffiliations: 'fetching-affiliations',
}

export default {
    name: 'MyAffiliations',

    components: {
        // PageLoading
    },

    mixins: [notify],

    data() {
        return {
            affiliations: [],

            pagination: {
                sortBy: 'created_by',
                descending: true,
                page: 1,
                rowsPerPage: 10,
                rowsNumber: 0,
            },

            rowsPerPageOptions: [5, 10, 25, 50, 100],
        }
    },

    computed: {
        columns() {
            return [
                // {
                //     name: 'id',
                //     label: this.$t('general.id'),
                //     field: 'id',
                //     align: 'left',
                //     sortable: true,
                // },
                {
                    name: 'title',
                    label: this.$t('general.company'),
                    field: (row) => row.clients.title,
                    align: 'left',
                    sortable: true,
                },
                {
                    name: 'start_date',
                    label: this.$t('general.start_date'),
                    field: 'start_date',
                    align: 'left',
                    sortable: true,
                },
                {
                    name: 'end_date',
                    label: this.$t('general.end_date'),
                    field: 'end_date',
                    align: 'left',
                    sortable: true,
                },
            ]
        },

        isLoading() {
            return this.isFetchingAffiliations
        },

        isFetchingAffiliations() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingAffiliations
            ).length
        },

        user() {
            return store.getters['session/user']
        },
    },

    async created() {
        await this.fetchAffiliations()
    },

    methods: {
        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(value, 'date', 'DD/MM/YYYY')
                : null
        },

        request(props) {
            const { page, rowsPerPage, sortBy, descending } = props.pagination

            this.pagination.page = page
            this.pagination.rowsPerPage = rowsPerPage
            this.pagination.sortBy = sortBy
            this.pagination.descending = descending

            this.fetchAffiliations()
        },

        mapColumn(value) {
            return value == null ? this.pagination.sortBy : value
        },

        mapOrder(value) {
            return value == true ? 'desc' : 'asc'
        },

        async fetchAffiliations() {
            this.loadingAdd(loadingKeys.fetchingAffiliations)

            let parameters = {
                pagination: {
                    perPage: this.pagination.rowsPerPage,
                    currentPage: this.pagination.page,
                },
                orderBy: [
                    {
                        column: this.mapColumn(this.pagination.sortBy),
                        direction: this.mapOrder(this.pagination.descending),
                    },
                ],
                filter: {
                    userId: this.user.id,
                },
                relations: {
                    clients: true,
                },
            }

            let response = await affiliationsService.clients.retrieve(
                parameters
            )

            if (response.status === 200) {
                this.affiliations = response.data.results
            } else {
                //TODO: error message
            }

            this.loadingRemove(loadingKeys.fetchingAffiliations)
        },
    },
}
</script>
